"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'ads/v1';
var AD_ACCOUNTS_BASE = API_BASE + "/ad-account";
var LEAD_SYNCING_BASE = API_BASE + "/leadSync";
var THIRTY_SECONDS_IN_MS = 30000;
var SIXTY_SECONDS_IN_MS = 60000;

var AccountsAPI =
/*#__PURE__*/
function () {
  function AccountsAPI() {
    (0, _classCallCheck2.default)(this, AccountsAPI);
  }

  (0, _createClass2.default)(AccountsAPI, null, [{
    key: "getAdAccounts",
    value: function getAdAccounts() {
      // Provide a longer timeout of 60s for this call, since some customers
      // have connected _many_ ad accounts (sometimes over a hundred).
      return _apiClient.default.get(API_BASE + "/profile/ad-accounts", {
        timeout: SIXTY_SECONDS_IN_MS
      });
    }
  }, {
    key: "getConnectedUsers",
    value: function getConnectedUsers() {
      return _apiClient.default.get(API_BASE + "/auth", {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }, {
    key: "deleteAdAccount",
    value: function deleteAdAccount(_ref) {
      var network = _ref.network,
          adAccountId = _ref.adAccountId;
      return _apiClient.default.delete(AD_ACCOUNTS_BASE + "/" + network.toLowerCase() + "/" + adAccountId, {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }, {
    key: "setTrackingForAdAccount",
    value: function setTrackingForAdAccount(_ref2) {
      var network = _ref2.network,
          adAccountId = _ref2.adAccountId,
          trackingEnabled = _ref2.trackingEnabled;
      return _apiClient.default.put(AD_ACCOUNTS_BASE + "/" + network.toLowerCase() + "/" + adAccountId + "/set-tracking", {
        timeout: THIRTY_SECONDS_IN_MS,
        query: {
          trackingEnabled: trackingEnabled
        }
      });
    }
  }, {
    key: "deleteUserAuth",
    value: function deleteUserAuth(_ref3) {
      var network = _ref3.network,
          networkUserId = _ref3.networkUserId;
      return _apiClient.default.delete(API_BASE + "/auth/" + network.toLowerCase() + "/" + networkUserId, {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
    /* Genericized lead syncing endpoints. */

  }, {
    key: "getAvailableLeadSyncingEntities",
    value: function getAvailableLeadSyncingEntities(_ref4) {
      var network = _ref4.network;
      return _apiClient.default.get(LEAD_SYNCING_BASE + "/" + network.toLowerCase() + "/available", {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }, {
    key: "getSelectedLeadSyncingEntities",
    value: function getSelectedLeadSyncingEntities() {
      return _apiClient.default.get(LEAD_SYNCING_BASE + "/selected", {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }, {
    key: "selectLeadSyncingEntities",
    value: function selectLeadSyncingEntities(_ref5) {
      var entityIds = _ref5.entityIds,
          network = _ref5.network;
      return _apiClient.default.put(LEAD_SYNCING_BASE + "/" + network.toLowerCase() + "/select", {
        timeout: THIRTY_SECONDS_IN_MS,
        query: {
          entityIds: entityIds
        }
      });
    }
  }, {
    key: "unsubscribeLeadSyncingEntity",
    value: function unsubscribeLeadSyncingEntity(_ref6) {
      var entityId = _ref6.entityId,
          network = _ref6.network;
      return _apiClient.default.delete(LEAD_SYNCING_BASE + "/" + network.toLowerCase() + "/entity/" + entityId + "/unsubscribe", {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }, {
    key: "changeEmailLessFormSubmissionsSetting",
    value: function changeEmailLessFormSubmissionsSetting(_ref7) {
      var allowEmailLessFormSubmissions = _ref7.allowEmailLessFormSubmissions;
      return _apiClient.default.put(LEAD_SYNCING_BASE + "/email-less-form-submissions", {
        timeout: THIRTY_SECONDS_IN_MS,
        query: {
          allowEmailLessFormSubmissions: allowEmailLessFormSubmissions
        }
      });
    }
  }]);
  return AccountsAPI;
}();

exports.default = AccountsAPI;
module.exports = exports.default;